import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import "mdn-polyfills/Array.from";

$(document).ready(function() {
  if (!Abacus.PreventDefault.HotTopics) {
    $(".hot-topics-container").each(function() {
      new HotTopics(this);
    });
  }
});

let HotTopicsOptions = {
  topicList: "ul",
  topicItems: "li"
};

class HotTopics extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(HotTopicsOptions, options);
    this.getTotalWidth();
    // this.setUpEvents();
  }

  getTotalWidth() {
    let totalWidth = [...this.element.find(this.options.topicItems)].reduce(
      (accumulator, currentValue) => {
        return accumulator + $(currentValue).outerWidth(true);
      },
      0
    );
    this.setWidthToList(totalWidth);
  }

  setWidthToList(width) {
    setTimeout(() => {
      this.element.find(this.options.topicList).css("width", width + 10);
    }, 150);
    this.element.addClass("ready");
  }

  setUpEvents() {
    $(window).on("resize", () => this.getTotalWidth());
  }
}

export { HotTopics };



// WEBPACK FOOTER //
// ./Javascript/core/classes/hottopics.class.js